module.exports = __webpack_public_path__ + "static/media/Plymouth-Commons-bylaws.a35c90b0.pdf";